import { createContext } from "react";
const TextAncestorContext = createContext(!1);
var TextAncestorContext_default = TextAncestorContext;
export { TextAncestorContext, TextAncestorContext_default as default };
//# sourceMappingURL=TextAncestorContext.mjs.map
